import React, { forwardRef } from "react";
import { Button as RBButton } from "react-bootstrap";

const Button = forwardRef(({ ...props }, ref) => (
  <RBButton ref={ref} {...props} />
));

export default Button;
